var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "products-pxsdb-features-view"
  }, [_vm._m(0), _vm._v(" "), (_vm.entries) ? _c('tbody', _vm._l((_vm.entries), function(feature) {
    return _c('tr', {
      key: feature.key
    }, [_c('td', [_vm._v("\n        " + _vm._s(feature.key) + "\n      ")]), _vm._v(" "), _c('td', {
      staticClass: "even"
    }, [_vm._v("\n        " + _vm._s(feature.name) + "\n      ")]), _vm._v(" "), _c('td', {
      staticClass: "value"
    }, [_c('ul', {
      staticClass: "values"
    }, _vm._l((feature.values), function(value, index) {
      return _c('li', {
        key: index
      }, [_vm._v("\n            " + _vm._s(value) + "\n          ")])
    }))])])
  })) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Key")]), _vm._v(" "), _c('th', {
    staticClass: "even"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Values")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55c245ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/ProductFamilies/PxsdbFeaturesView.vue
// module id = 1990
// module chunks = 0